@for (vap of vaps; track vap; let i = $index) {
  <div class="addon-expander addon-expander--checkbox">
    <div class="addon-expander__header">
      <label class="custom-input custom-input--checkbox">
        <input type="checkbox"
          [checked]="vap?.checked"
          [id]="'checkbox' + currentVap?.product_vaps_id + '-' + vap?.session_item_id"
          (click)="checkAddon(i)"
          [class]="'addon-' + currentVap?.product_vaps_id"/>
          <span class="custom-input__indi"></span>
        </label>
        <a [href]="'#addon-vehicle-field-' + vap?.session_item_id"
          (click)="$event.preventDefault();"
          class="addon-expander__title"
          [ngClass]="{'collapsed': !vap?.show}"
          data-toggle="collapse"
          aria-expanded="false">
          <h6>{{vap?.description?.length ? vap?.description[2] : 'Add Cover'}}</h6>
          <div [class]="'addon-expander__cost ' + vap?.active">
            <p>
              <strong
                [class]="currentVap?.product_vaps_id + '-' + vap?.session_item_id + '-price addon-price-' + currentVap?.product_vaps_id + ' addon-' + currentVap?.product_vaps_id">
              {{vap?.price | currency:'ZAR':'R ':'1.0-0'}}</strong> /mo</p>
            </div>
            <div class="addon-expander__caret">
              <svg class="icon">
                <use xlink:href="#dropdown"></use>
              </svg>
            </div>
          </a>
        </div>
        <div class="addon-expander__content collapse"
          [ngClass]="{'show': vap?.show}"
          [id]="'addon-vehicle-field-' + vap?.session_item_id">
          <div class="modal-addons__item">
            <div class="form-group">
              <label [for]="question?.cent_aq_question_id">{{question?.question_copy}}</label>
              <input mask="percent"
                suffix="%"
                type="tel"
                maxlength="3"
                [(ngModel)]="vap.value"
                (ngModelChange)="onChange(i, 0)"
                [class]="'form-control answers ' + question?.cent_aq_question_id"
                [placeholder]="'Max ' + currentVap?.value_max + '%'"/>
              </div>
            </div>
          </div>
        </div>
      }
